import { TRACK_STATUS_CLOSED, TRACK_STATUS_OPEN, TRACK_STATUS_WAITING } from "./constants";

export const tracksColors = {
	blue: '#007AFF',
	red: '#FF3B30',
	black: '#000000',
	green: '#4CAF50', // Зелені траси
	open: '#00BF30',
	closed: '#FFA500'
};

/**
 * Get label colors
 * @type {{red: string, blue: [string, string], black: string, green: [string, string], closed: string, open: string}}
 */
export const labelColors = {
	blue: ['#A7CFFB', '#007AFF'],
	red: ['#FBBAB7', '#FF3B30'],
	black: ['#A7A7A7', '#000000'],
	green: ['#C8E6C9', '#4CAF50'], // Світло-зелений зовні, яскраво-зелений всередині
	open: ['#BAF1D1', '#15BC40'],
	closed: ['#FFD776', '#FFA500']
};

export const labelColorsByTrackStatus = {
	[TRACK_STATUS_OPEN]: labelColors.open,
	[TRACK_STATUS_WAITING]: labelColors.closed,
	[TRACK_STATUS_CLOSED]: labelColors.red
};

export const liftsColors = {
	open: ['#4A4A4A', '#000000', '#212121'],
	//closed: ['#4A4A4A', '#000000', '#212121'],
	closed: ['#777', '#999', '#999']
};

export const liftsColorsStatus = {
	open: ['#25E47A', '#000000', '#212121'],
	closed: ['#FF7300', '#000', '#000']
};
